var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkLocationBar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03906 20.3867C7.57812 20.3867 7.17188 20.1602 6.82031 19.707L0.738281 11.9609C0.621094 11.8203 0.535156 11.6797 0.480469 11.5391C0.425781 11.3906 0.398438 11.2461 0.398438 11.1055C0.398438 10.7852 0.503906 10.5234 0.714844 10.3203C0.925781 10.1094 1.19531 10.0039 1.52344 10.0039C1.91406 10.0039 2.25 10.1953 2.53125 10.5781L7.99219 17.7266L18.5156 0.957031C18.6562 0.738281 18.8008 0.585937 18.9492 0.5C19.0977 0.40625 19.2891 0.359375 19.5234 0.359375C19.8438 0.359375 20.1016 0.457031 20.2969 0.652344C20.4922 0.847656 20.5898 1.10547 20.5898 1.42578C20.5898 1.56641 20.5664 1.70703 20.5195 1.84766C20.4727 1.98047 20.3984 2.12891 20.2969 2.29297L9.22266 19.7305C8.93359 20.168 8.53906 20.3867 8.03906 20.3867Z",
    fill: "#018D8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkLocationBar);
export default __webpack_public_path__ + "static/media/checkmark-location-bar.7f3c7fd3d27ccb13df41d8bfbfd6bb4e.svg";
export { ForwardRef as ReactComponent };